export default __webpack_public_path__ + "static/media/Pin-Point-Alamat-icon.3c939e26.svg";